module.exports = __webpack_public_path__ + "img/yuanxiaozyzshoucang2.4959886a.png";